import auth from './auth';
import errors from './errors';
import nav from './nav';
import locale from './locale';
import users from './users';
import property from './property';
import preferences from './preferences';
import message from './message';

export default {
  auth,
  locale,
  nav,
  errors,
  users,
  property,
  preferences,
  message,
};
